import { getCategoryInfo } from '../../../../shared/utils';

import configsByCategory from './configs-by-category';
import configsByCategoryForAreaPartV2 from './configs-by-category/commercial-area-parts-v2';
import configsByCategoryCoworking from './configs-by-category/commercial-coworking';

function getRowName(row) {
  switch (typeof row) {
    case 'object':
      return row.name;
    default:
      return row;
  }
}

function formatRowName(rowName, segment) {
  const parts = rowName.split('/');
  const name = parts.pop();
  const path = parts.join('-') || segment;

  return `cian-af-${path}-${name}`;
}

function getSegment(settings, category) {
  if (settings) {
    const { coworkingOfferType, isCommercialBusinessAvailable } = settings;

    if (coworkingOfferType in configsByCategoryCoworking && category === 'officeRent') {
      return configsByCategoryCoworking[coworkingOfferType];
    }

    if (isCommercialBusinessAvailable) {
      return configsByCategory.businessSale;
    }
  }

  return configsByCategoryForAreaPartV2[category] || configsByCategory[category];
}

function getRowsBySettings(category, rows, settings, segment) {
  if (!rows) {
    return [];
  }

  const { dealType } = getCategoryInfo(category);
  const isRentDealType = dealType === 'rent';

  if (settings?.isByCommercialOwner && isRentDealType && rows.includes('fee')) {
    return [...rows.filter(row => row !== 'fee'), 'agent-bonus'];
  }

  if (!isRentDealType && segment !== 'address') {
    return rows.filter(row => row !== 'common/cottage-village-name');
  }

  return rows;
}

export default function (category, segment, settings) {
  let result = null;
  const rowsBySegment = getSegment(settings, category);

  if (!rowsBySegment) {
    console.error(`No rows config for category '${category}'`);
  }

  const rows = getRowsBySettings(category, rowsBySegment[segment], settings, segment);

  if (Array.isArray(rows)) {
    result = rows.map(rowObj => {
      const name = formatRowName(getRowName(rowObj), segment);
      const rowData = typeof rowObj === 'object' ? rowObj : {};

      return {
        ...rowData,
        name,
      };
    });
  }

  return result;
}
